import { Box, Center, Flex, ListItem, Spinner, Text, UnorderedList } from '@chakra-ui/react';
import { useContext, useEffect } from 'react';
import { AuthenticatedComponent } from '../../auth/keycloak';
import PageDataContext from '../../context/PageDataContext';
import { usePageDataCache } from '../../hooks/usePageDataCache';
import { getUserInventory, InventoryDef } from '../../service/inventory';
import { getUserPrivateProfile, UserPrivateProfile } from '../../service/social';
import { AvatarImage } from './AvatarImage';

export const VaultCurrency: AuthenticatedComponent = ({ keycloak }) => {
    const { isLoadFromCache } = useContext(PageDataContext);
    const localStoragePrefix = 'VaultCurrency';

    const [userProfile, setUserProfile] = usePageDataCache<UserPrivateProfile | undefined>(
        `${localStoragePrefix}}_userProfile`,
        undefined,
    );

    const [imageUrl, setImageUrl] = usePageDataCache(`${localStoragePrefix}}_imageUrl`, '');
    const [isLoading, setIsLoading] = usePageDataCache(`${localStoragePrefix}}_isLoading`, true);
    const [inventory, setInventory] = usePageDataCache<InventoryDef[]>(
        `${localStoragePrefix}}_inventory`,
        [],
    );

    useEffect(() => {
        async function getProfileInfo() {
            const profile = await getUserPrivateProfile(keycloak.subject, keycloak.token);
            setUserProfile(profile);
        }
        if (!isLoadFromCache) {
            getProfileInfo();
            getInventory();
        }
    }, []);

    useEffect(() => {
        if (userProfile) {
            setImageUrl(userProfile.avatar_object_url);

            setIsLoading(false);
        }
    }, [userProfile]);

    const getInventory = async () => {
        setInventory([]);
        try {
            const invs = await getUserInventory(
                keycloak.subject,
                'streamsix_currency',
                '',
                keycloak.token,
            );
            setInventory(invs);
        } catch (err: any) {
            console.error(err);
            setInventory([]);
        }
    };

    return (
        <>
            {isLoading && userProfile ? (
                <Center width="100%" height="100%">
                    <Spinner data-cy="loading" />
                </Center>
            ) : (
                <Box borderBottom={'1px solid black'}>
                    <Flex
                        direction={'column'}
                        justify={'center'}
                        alignItems={'center'}
                        width="80%"
                        m="0 auto"
                    >
                        <Box boxSize="175px" mt="2em" mb="2em">
                            <AvatarImage
                                boxSize="175px"
                                objectFit="cover"
                                borderRadius="full"
                                src={imageUrl}
                                alt={`${userProfile?.username}'s avatar`}
                            />
                        </Box>
                        <Center>
                            <UnorderedList listStyleType={'none'} m={'0'} p={'2em 0'}>
                                {inventory.map((inv, i) => (
                                    <ListItem
                                        key={`user_inventory_${i}`}
                                        data-cy={'user_inventory'}
                                    >
                                        <Text>{`${inv.quantity} ${inv.inventory_item.item_name}`}</Text>
                                    </ListItem>
                                ))}
                            </UnorderedList>
                        </Center>
                    </Flex>
                </Box>
            )}
        </>
    );
};
